/*
 * @Author: hzm
 * @Date: 2022-12-14 14:17:29
 * @Description:
 */
/*
 * @Author: hzm
 * @Date: 2022-07-11 16:36:47
 * @Description:
 */
import { READSTATUS } from 'mroshopcommon';
import { useMessageStore } from '@/stores/message';
export default function () {
  const store = useMessageStore();
  const msgDetailDialog = reactive({
    open: false,
    detail: '',
    title: '',
  });

  function openMsgDialog(message: API.MsgPush) {
    msgDetailDialog.detail = message.content ?? '';
    msgDetailDialog.open = true;
    msgDetailDialog.title = message.title ?? '';
    if (message.status == READSTATUS.NOTREAD) readMsg(message);
  }

  function readMsg(message: API.MsgPush) {
    return store
      .readSingleMsg({
        id: message.id,
        messageId: message.messageId,
      })
      .then(res => {
        store.getUserNotReadMsgList({});
      });
  }

  return {
    msgDetailDialog,
    openMsgDialog,
    readMsg,
  };
}
